
import { defineComponent, computed } from "vue";
import Timer from "@/components/Timer.vue";
import moment from "moment";
import { useStore } from "@/store";
import { ActionTypes } from "@/store/actions";

const data = {
  soundurl: "/se/mog_happy.mp3",
};

export default defineComponent({
  name: "event-countdown",
  props: {
    dates: {
      type: Object,
      default: () => {
        return { start: "", end: "" };
      },
    },
    isReset: {
      type: Boolean,
    },
  },
  setup() {
    const store = useStore();
    const sound = computed(() => store.state.sound);

    return { sound, store };
  },
  data() {
    return {
      startMoment: {} as moment.Moment,
      activeDate: this.dates.start,
    };
  },
  mounted() {
    this.activeDate = this.dates.start;
    this.startMoment = moment.utc(this.dates.start);
    if (this.isReset) {
      const timeLeft = moment
        .duration(this.startMoment.diff(moment()))
        .asMilliseconds();
      this.$options.reset = window.setTimeout(() => {
        this.playSound();
        this.store.dispatch(ActionTypes.RefreshReset);
      }, timeLeft);
    }

    if (this.startMoment.diff(moment()) < 1 && this.dates.end.length > 0)
      this.activeDate = this.dates.end;
    else this.tick();
  },
  beforeUnmount() {
    window.clearTimeout(this.$options.timer);
    window.clearTimeout(this.$options.reset);
  },
  methods: {
    tick(timeout = 50) {
      this.$options.timer = window.setTimeout(this.updateDate, timeout);
    },
    updateDate() {
      if (this.startMoment.diff(moment()) < 1 && this.dates.end.length > 0)
        this.activeDate = this.dates.end;
      else this.tick();
    },
    playSound() {
      const audio = new Audio(data.soundurl);
      if (this.sound) {
        audio.play();
      }
    },
  },
  computed: {
    timeLeftInMs() {
      return moment
        .duration(moment(this.activeDate).diff(moment()))
        .asMilliseconds();
    },
  },
  watch: {
    dates() {
      this.activeDate = this.dates.start;
      this.startMoment = moment.utc(this.dates.start);
      if (this.isReset) {
        const timeLeft = moment
          .duration(this.startMoment.diff(moment()))
          .asMilliseconds();
        this.$options.reset = window.setTimeout(() => {
          this.playSound();
          this.store.dispatch(ActionTypes.RefreshReset);
        }, timeLeft);
      }

      if (this.startMoment.diff(moment()) < 1 && this.dates.end.length > 0)
        this.activeDate = this.dates.end;
      else this.tick();
    },
  },
  components: {
    Timer,
  },
});
